import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-broadcastings-config-properties-card',
  templateUrl: './broadcastings-config-properties-card.component.html',
  styleUrls: ['./broadcastings-config-properties-card.component.scss']
})
export class BroadcastingsConfigPropertiesCardComponent implements OnInit {

  @Input() properties;
  items;

  constructor() { }

  ngOnInit() {
    if (this.properties) {
      this.items = this.parseData();
    }
  }

  // ngOnChanges() {
  //   if (this.properties) {
  //     this.items = this.parseData();
  //   }
  // }

  private parseData() {
    const d = [];
    Object.entries(JSON.parse(this.properties)).forEach(v => {
      d.push({ key: v[0], value: v[1] });
    });
    return d;
  }

}
